var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pageMode == "main_page"
        ? _vm._t("main_page")
        : _vm.pageMode == "sub_page"
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "container-fix-padding bg-white",
                attrs: { fluid: "" },
              },
              [
                _c("div", { staticClass: "min-vh-100 p-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "h5 mb-0 p-2 cursor-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.onSwitchMode("main_page")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "bi bi-chevron-left" }),
                      _vm._v("\n                    戻る\n                "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [_vm._t("sub_page")], 2),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }